import { render, staticRenderFns } from "./ObjectMenuItem.vue?vue&type=template&id=2cdc1260&scoped=true"
import script from "./ObjectMenuItem.vue?vue&type=script&lang=ts"
export * from "./ObjectMenuItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdc1260",
  null
  
)

export default component.exports